// 客户管理
export default [

  //优惠券
  {
    path: '/user/coupon',
    name: '/user/coupon',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/fundManagement/coupon'),
    meta: {
      activeMenu: '/user/coupon', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },

  //充值
  {
    path: '/user/recharge',
    name: '/user/recharge',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/fundManagement/recharge'),
    meta: {
      activeMenu: '/user/recharge', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },

  //商品库
  {
    path: '/user/commodityWarehouse',
    name: '/user/commodityWarehouse',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/favorites/commodityWarehouse'),
    meta: {
      activeMenu: '/user/commodityWarehouse', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  出入金明细
  {
    path: '/user/detailsOfIncomingAndOutgoingFunds',
    name: '/user/detailsOfIncomingAndOutgoingFunds',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/fundManagement/detailsOfIncomingAndOutgoingFunds'),
    meta: {
      activeMenu: '/user/detailsOfIncomingAndOutgoingFunds', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  提现记录
  {
    path: '/user/withdrawalRecord',
    name: '/user/withdrawalRecord',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/fundManagement/withdrawalRecord'),
    meta: {
      activeMenu: '/user/withdrawalRecord', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  配送单
  {
    path: '/user/deliveryOrder',
    name: '/user/deliveryOrder',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/order/deliveryOrder'),
    meta: {
      activeMenu: '/user/deliveryOrder', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  订单列表
  {
    path: '/user/orderList',
    name: '/user/orderList',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/order/orderList'),
    meta: {
      activeMenu: '/user/orderList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  中国国内物流
  {
    path: '/user/chineseDomesticLogistics',
    name: '/user/chineseDomesticLogistics',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/order/chineseDomesticLogistics'),
    meta: {
      activeMenu: '/user/chineseDomesticLogistics', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  订单支付页面
  {
    path: '/user/payPage',
    name: 'payPage',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/order/payPage'),
    meta: {
      activeMenu: '/user/orderList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  用户仓库
  {
    path: '/user/userWarehouse',
    name: '/user/userWarehouse',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/order/warehouse'),
    meta: {
      activeMenu: '/user/userWarehouse', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  用户面板
  {
    path: '/user/panel',
    name: '/user/panel',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/panel'),
    meta: {
      activeMenu: '/user/panel', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  地址
  {
    path: '/user/address',
    name: '/user/address',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/userManagement/address'),
    meta: {
      activeMenu: '/user/address', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  用户基础信息
  {
    path: '/user/basicInformation',
    name: '/user/basicInformation',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/userManagement/basicInformation'),
    meta: {
      activeMenu: '/user/basicInformation', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  客户数据分析
  {
    path: '/user/dataAnalysis',
    name: '/user/dataAnalysis',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/userManagement/dataAnalysis'),
    meta: {
      activeMenu: '/user/dataAnalysis', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  客户邮件
  {
    path: '/user/userEmailList',
    name: '/user/userEmailList',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/userManagement/userEmailList'),
    meta: {
      activeMenu: '/user/userEmailList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },

  //  子账户
  {
    path: '/user/subaccount',
    name: '/user/subaccount',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/userManagement/subaccount'),
    meta: {
      activeMenu: '/user/subaccount', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  出入金
  {
    path: '/user/churujinList',
    name: '/user/churujinList',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/fundManagement/churujinList'),
    meta: {
      activeMenu: '/user/churujinList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //  邮件接收设置
  {
    path: '/user/emailBlockConfig',
    name: '/user/emailBlockConfig',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userOrderManagement/userManagement/emailBlockConfig'),
    meta: {
      activeMenu: '/user/emailBlockConfig', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },


]